export const scenarios = [
  {
    id: 'over-a-phone-call',
    title: 'Over a phone call',
    description: 'Ring ring! Master the art of phone conversations with a friend. Navigate small talk, catch up on life updates, and plan future hangouts all while building confidence in spoken English!',
    iconName: 'phone',
    status: 'free',
    objectives: [
      { id: 'phone-1', text: 'Ask how is your friend doing' },
      { id: 'phone-2', text: 'Ask how is everyone at his home' },
      { id: 'phone-3', text: 'Ask how is his work pressure' },
      { id: 'phone-4', text: 'Ask about his holiday plans for the weekend' }
    ]
  },
  {
    id: 'restaurant',
    title: 'At a restaurant',
    description: 'From "Table for two, please" to the final "Check, please!" Navigate the culinary adventure of dining out. Learn to order like a local and handle restaurant interactions with confidence and proper etiquette.',
    iconName: 'restaurant',
    status: 'free',
    objectives: [
      { id: 'rest-1', text: 'Greet the server and ask for a table' },
      { id: 'rest-2', text: 'Ask about the menu recommendations' },
      { id: 'rest-3', text: 'Order your food with specific preferences' },
      { id: 'rest-4', text: 'Request the bill and thank the server' }
    ]
  },
  {
    id: 'nike-store',
    title: 'At a Nike store',
    description: 'Step into the world of sportswear shopping! Browse the latest collections, find your perfect fit, score great deals, and walk out with both new kicks and newfound English shopping vocabulary.',
    iconName: 'shopping',
    status: 'free',
    objectives: [
      { id: 'nike-1', text: 'Ask for help finding specific items' },
      { id: 'nike-2', text: 'Inquire about sizes and colors' },
      { id: 'nike-3', text: 'Ask about discounts or ongoing sales' },
      { id: 'nike-4', text: 'Make a purchase and handle payment' }
    ]
  },
  {
    id: 'coffee-shop',
    title: 'At a coffee shop',
    description: 'Espresso yourself! Navigate the buzzing atmosphere of a café, decode the coffee lingo, customize your perfect brew, and engage in the time-honored tradition of café conversation.',
    iconName: 'coffee',
    status: 'free',
    objectives: [
      { id: 'coffee-1', text: 'Order your preferred coffee drink' },
      { id: 'coffee-2', text: 'Request customizations to your order' },
      { id: 'coffee-3', text: 'Ask about food options available' },
      { id: 'coffee-4', text: 'Handle payment and tipping' }
    ]
  },
  {
    id: 'first-day-class',
    title: 'First day of class',
    description: 'New classroom, new faces! Break the ice, share your story, and make meaningful connections on your academic journey. Turn first-day jitters into confident classroom communication.',
    iconName: 'class',
    status: 'free',
    objectives: [
      { id: 'class-1', text: 'Introduce yourself to the class' },
      { id: 'class-2', text: 'Share your interests and background' },
      { id: 'class-3', text: 'Ask questions about the course' },
      { id: 'class-4', text: 'Exchange contact info with classmates' }
    ]
  },
  {
    id: 'birthday-celebration',
    title: 'Birthday celebration',
    description: 'Cake, candles, and celebrations! Learn the perfect birthday wishes, navigate gift-giving customs, plan the perfect party, and create memorable moments in this joyful social scenario.',
    iconName: 'birthday',
    status: 'free',
    objectives: [
      { id: 'bday-1', text: 'Wish someone happy birthday' },
      { id: 'bday-2', text: 'Give and receive birthday gifts' },
      { id: 'bday-3', text: 'Make plans for celebration' },
      { id: 'bday-4', text: 'Express gratitude for celebration' }
    ]
  }
];